/* Handmade By Hunter — global scripts (vanilla JS, no dependencies) */
(function () {
  'use strict';

  /* ---- Mobile nav toggle ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-site-nav]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  /* ---- Product gallery: click a thumb to swap the main image ---- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-gallery-main]');
    if (main && thumb.dataset.full) {
      main.src = thumb.dataset.full;
      main.srcset = '';
    }
  });

  /* ---- Quantity stepper ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += btn.dataset.qty === 'up' ? 1 : -1;
    if (val < 1) val = 1;
    input.value = val;
  });

  /* ---- Variant picker: update the hidden id + price ---- */
  var variantData = null;
  var picker = document.querySelector('[data-variant-picker]');
  if (picker) {
    try { variantData = JSON.parse(document.getElementById('variant-json').textContent); } catch (err) {}
    picker.addEventListener('change', function () {
      if (!variantData) return;
      var chosen = variantData.find(function (v) { return String(v.id) === picker.value; });
      if (!chosen) return;
      var idField = document.querySelector('[data-variant-id]');
      if (idField) idField.value = chosen.id;
      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl && typeof chosen.price === 'number') {
        priceEl.textContent = formatMoney(chosen.price);
      }
      var addBtn = document.querySelector('[data-add-to-cart]');
      if (addBtn) {
        addBtn.disabled = !chosen.available;
        addBtn.textContent = chosen.available ? addBtn.dataset.label : 'Sold out';
      }
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- Add to cart via AJAX, then bump the header count ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: form.querySelector('[data-variant-id]').value,
        quantity: parseInt(form.querySelector('[name="quantity"]').value, 10) || 1
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var count = document.querySelector('[data-cart-count]');
        if (count) { count.textContent = cart.item_count; count.hidden = false; }
        if (btn) { btn.textContent = 'Added ✓'; }
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
        }, 1600);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
        window.location.href = '/cart';
      });
  });

  /* ---- Reveal-on-scroll for a gentle, cozy entrance ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  }
})();
